const Health = (props) => {
    return (
        <p>Site health check</p>
    )
}


export default Health